
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge as UIBadge } from "@/components/ui/badge";
import { Award } from "lucide-react";

interface Badge {
  id: string;
  name: string;
  description: string;
  awarded_at: string;
}

interface BadgesListProps {
  badges: Badge[];
}

export function BadgesList({ badges }: BadgesListProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Award className="h-5 w-5" />
          Behaalde badges
        </CardTitle>
      </CardHeader>
      <CardContent>
        {badges.length === 0 ? (
          <p className="text-sm text-muted-foreground">
            Nog geen badges behaald. Blijf actief om badges te verdienen!
          </p>
        ) : (
          <div className="flex flex-wrap gap-2">
            {badges.map((badge) => (
              <UIBadge key={badge.id} variant="secondary">
                {badge.name}
              </UIBadge>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
